import { render, staticRenderFns } from "./group.component.vue?vue&type=template&id=1a4a479a&scoped=true&"
import script from "./group.component.vue?vue&type=script&lang=js&"
export * from "./group.component.vue?vue&type=script&lang=js&"
import style0 from "./group.component.vue?vue&type=style&index=0&id=1a4a479a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a479a",
  null
  
)

export default component.exports